export const userConstants = {
  REGISTER_REQUEST: "USERS_REGISTER_REQUEST",
  REGISTER_SUCCESS: "USERS_REGISTER_SUCCESS",
  REGISTER_FAILURE: "USERS_REGISTER_FAILURE",

  LOGIN_REQUEST: "USERS_LOGIN_REQUEST",
  LOGIN_SUCCESS: "USERS_LOGIN_SUCCESS",
  LOGIN_FAILURE: "USERS_LOGIN_FAILURE",

  LOGOUT: "USERS_LOGOUT",

  GET_ALL_REQUEST: "USERS_GET_ALL_REQUEST",
  GET_ALL_SUCCESS: "USERS_GET_ALL_SUCCESS",
  GET_ALL_FAILURE: "USERS_GET_ALL_FAILURE",

  GET_ONE_REQUEST: "USERS_GET_ONE_REQUEST",
  GET_ONE_SUCCESS: "USERS_GET_ONE_SUCCESS",
  GET_ONE_FAILURE: "USERS_GET_ONE_FAILURE",

  UPDATE_REQUEST: "USERS_UPDATE_REQUEST",
  UPDATE_SUCCESS: "USERS_UPDATE_SUCCESS",
  UPDATE_FAILURE: "USERS_UPDATE_FAILURE",

  GET_CURRENT_REQUEST: "USERS_GET_CURRENT_REQUEST",
  GET_CURRENT_SUCCESS: "USERS_GET_CURRENT_SUCCESS",
  GET_CURRENT_FAILURE: "USERS_GET_CURRENT_FAILURE",

  DELETE_REQUEST: "USERS_DELETE_REQUEST",
  DELETE_SUCCESS: "USERS_DELETE_SUCCESS",
  DELETE_FAILURE: "USERS_DELETE_FAILURE",


  DELETE_MANY_REQUEST: "USERS_DELETE_MANY_REQUEST",
  DELETE_MANY_SUCCESS: "USERS_DELETE_MANY_SUCCESS",
  DELETE_MANY_FAILURE: "USERS_DELETE_MANY_FAILURE",

  ADD_TO_CART_REQUEST: "USER_ADD_TO_CART_REQUEST",
  ADD_TO_CART_SUCCESS: "USER_ADD_TO_CART_SUCCESS",
  ADD_TO_CART_FAILURE: "USER_ADD_TO_CART_FAILURE",

  EDIT_CART_REQUEST: "USER_EDIT_CART_REQUEST",
  EDIT_CART_SUCCESS: "USER_EDIT_CART_SUCCESS",
  EDIT_CART_FAILURE: "USER_EDIT_CART_FAILURE",

  GET_PRODUCTS_IN_CART_REQUEST: "GET_PRODUCTS_IN_CART_REQUEST",
  GET_PRODUCTS_IN_CART_SUCCESS: "GET_PRODUCTS_IN_CART_SUCCESS",
  GET_PRODUCTS_IN_CART_FAILURE: "GET_PRODUCTS_IN_CART_FAILURE",

  GET_RECEIPTS_REQUEST: "USER_GET_RECEIPTS_REQUEST",
  GET_RECEIPTS_SUCCESS: "USER_GET_RECEIPTS_SUCCESS",
  GET_RECEIPTS_FAILURE: "USER_GET_RECEIPTS_FAILURE",
};

